function findAsins(text: string): Array<string> {
  const asins: Array<string> = [] //no idea why using const here... got error otherwise. didn't know const could change :/

  //if text is just a link (starts with http, no spaces) search for /dp/{asin} and extract {asin}
  if (text.startsWith('http') && !text.includes(' ')) {
    const match = text.match(/\/dp\/([A-Z0-9]{10})\b/)
    if (match) {
      const asin = match[1]
      if (!asins.includes(asin)) asins.push(asin)
    }
    return asins
  }

  //else, search for any 10 digits number or string (we could be more aggressive here...)
  const regex = /\b[A-Z0-9]{10}\b/g
  text.match(regex)?.forEach((asin) => {
    if (!asins.includes(asin)) asins.push(asin)
  })

  return asins
}

export default { findAsins }
